/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

import logo from "./../../assets/images/logo.png";

export class Logotype extends React.Component {
  render() {
    return (
      <a href="#" className="logotype">
        <img className="site-logo" src={logo} alt="ATPT" />
        <h1>ATPT</h1>
      </a>
    );
  }
}
